import { Component, Input } from '@angular/core';

@Component({
  selector: 'sn-expand-icon',
  templateUrl: './expand-icon.component.html',
  styleUrls: ['./expand-icon.component.scss'],
})
export class SnExpandIconComponent {
  @Input() public expanded: false;
}
